import _ from 'underscore';

partnerService.$inject = [
  '$rootScope',
  '$location',
  '$window',
  'tl.http',
  'tl.query',
  '$state',
  'utilsService',
  'tl.config',
  'partnerConfigs',
  'jsSdk.config'
];

export default function partnerService($rootScope, $location, $window, $http, query, $state, utilsService, tlConfig, partnerConfigs, jsSdkConfig) {
  function getSubdomain() {
    const subdomain = query.subdomain().replace('-dev', '');

    return subdomain !== 'localhost' ? subdomain : null;
  }

  class PartnerService {
    init() {
      const partner = query.get('partner') || getSubdomain();

      const partnerName = partner || 'www';

      this.partner = partnerConfigs[partnerName] || _.find(_.values(partnerConfigs), {
        slug: partnerName
      }) || partnerConfigs.www;

      this.partner.configure();

      // NightPro Attribution ID
      if (this.partner.attributionId) {
        jsSdkConfig.setAttributionId(this.partner.attributionId);
      }

      // NightPro Attribution Type
      if (this.partner.attributionType) {
        jsSdkConfig.setAttributionType(this.partner.attributionType);
      }
    }

    filterByAllowedItemTypes(itemTypes) {
      return this.partner ? this.partner.filterByAllowedItemTypes(itemTypes) : null;
    }

    filterCities(cities) {
      return this.partner ? this.partner.filterCities(cities) : null;
    }

    getTags() {
      return this.partner ? this.partner.getTags() : null;
    }

    getItemType() {
      return this.partner ? this.partner.getItemType() : null;
    }
  }

  return new PartnerService();
}



// WEBPACK FOOTER //
// ./src/services/partnerService.js